import {defineMessages} from 'react-intl';

export default defineMessages({
  selectRangeLabel: {
    defaultMessage: 'Select a range',
    id: 'DateRangeFilter.Picker'
  }
});
